// //ページ内遷移
// $(function () {
//     $('a[href^="#"]').click(function () {
//         var href = $(this).attr('href');
//         var target = $(href == '#' || href == '' ? 'html' : href);
//         var headerHeight = $('.header__fukuyama').height(); // ヘッダーの高さを取得
//         var position = target.offset().top - headerHeight;
//         console.log(position);
//         $('html, body').animate({ scrollTop: position }, 300);
//         return false;
//     });
// });

// //ページ内遷移（別ページの場合）
// $(function () {
//     var urlHash = location.hash;
//     var headerHeight = $('.header__fukuyama').height();
//     if (urlHash) {
//         $('body,html').stop().scrollTop(0);
//         setTimeout(function () {
//             var target = $(urlHash);
//             var position = target.offset().top - headerHeight;
//             $('body,html').stop().animate({ scrollTop: position }, 500);
//         }, 100);
//     }
// });

//アコーディオン
$(function () {
    $(".acdn").on('click', function () {
        $(this).next('.acdn_content').slideToggle(300); // クリックされた要素の次の.acdn_contentを制御
        $(this).toggleClass('--active'); // クリックされた要素にactiveクラスを付け外し
    });
});

//看護部のアコーディオン
$(function () {
    if ($(window).width() <= 767) {
        $(".acdn-education").on('click', function () {
            $(this).next('.nursing-department__education__content').toggleClass('flex-display'); // flex-displayクラスを付け外し
            $(this).toggleClass('--active');
        });
    }
});


//タブ機能

//ハンバーガーメニュー
$(function () {
    //「閉じる」がクリックされた場合
    $('.ham').on('click', function () {
        $('body').toggleClass("fixed");
    });
});

document.addEventListener("DOMContentLoaded", function () {
    // hamボタンの要素を取得
    var hamButton = document.querySelector('.header__fukuyama-right .ham');
    // modalの要素を取得
    var modal = document.querySelector('.modal');
    // header__menuの要素を取得
    var headerMenu = document.querySelector('.header__menu');

    // hamボタンがクリックされたときのイベントリスナーを設定
    if (hamButton) {
        hamButton.addEventListener('click', function () {
            // hamボタンに--activeクラスを付与または削除
            hamButton.classList.toggle('ham--active');
            hamButton.classList.toggle('ham--close');
            // modalに--activeクラスを付与または削除
            modal.classList.toggle('--active');
            // header__menuに--activeクラスを付与または削除
            headerMenu.classList.toggle('--active');
        });
    }
});

//スクロールヒント
window.addEventListener('DOMContentLoaded', function () {
    new ScrollHint('.js-scrollable', {
        scrollHintIconAppendClass: 'scroll-hint-icon-white',
        suggestiveShadow: true,
        i18n: {
            scrollable: "スクロールできます"
        }
    });
});

//クリックで拡大
document.addEventListener("DOMContentLoaded", function () {
    var modal = document.querySelector('.hospital-introduction__modal');
    var closeButton1 = document.querySelector('.hospital-introduction__expansion-img1 .close-btn');
    var closeButton2 = document.querySelector('.hospital-introduction__expansion-img2 .close-btn');


    if (document.querySelector('.hospital-introduction__map1 div')) {
        document.querySelector('.hospital-introduction__map1 div').addEventListener('click', function () {
            modal.classList.add('--active');
            document.querySelector('.hospital-introduction__expansion-img1').classList.add('--active');
        });
    }

    if (document.querySelector('.hospital-introduction__map2 div')) {
        document.querySelector('.hospital-introduction__map2 div').addEventListener('click', function () {
            modal.classList.add('--active');
            document.querySelector('.hospital-introduction__expansion-img2').classList.add('--active');
        });
    }

    if (closeButton1) {
        closeButton1.addEventListener('click', function () {
            modal.classList.remove('--active');

            if (document.querySelector('.hospital-introduction__expansion-img1')) {
                document.querySelector('.hospital-introduction__expansion-img1').classList.remove('--active');
            }
        });
    }

    if (closeButton2) {
        closeButton2.addEventListener('click', function () {
            modal.classList.remove('--active');
            if (document.querySelector('.hospital-introduction__expansion-img2')) {
                document.querySelector('.hospital-introduction__expansion-img2').classList.remove('--active');
            }
        });
    }
});

//クリックでポップアップ
document.addEventListener("DOMContentLoaded", function () {
    const modal1 = document.getElementById("modal1");
    const medicalStudentModal = document.querySelector(".modal");
    const medicalStudentCloseButton = document.getElementById("modal-meidal-student");

    if (modal1) {
        modal1.addEventListener("click", function () {
            medicalStudentModal.classList.add("--active");
            document.querySelector(".medical-student").classList.add("--active");
        });
    }

    if (medicalStudentCloseButton) {
        medicalStudentCloseButton.addEventListener("click", function () {
            medicalStudentModal.classList.remove("--active");
            document.querySelector(".medical-student").classList.remove("--active");
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const modal1 = document.getElementById("modal2");
    const medicalStudentModal = document.querySelector(".modal");
    const medicalStudentCloseButton = document.getElementById("modal-nursing-students");

    if (modal1) {
        modal1.addEventListener("click", function () {
            medicalStudentModal.classList.add("--active");
            document.querySelector(".nursing-students").classList.add("--active");
        });
    }

    if (medicalStudentCloseButton) {
        medicalStudentCloseButton.addEventListener("click", function () {
            medicalStudentModal.classList.remove("--active");
            document.querySelector(".nursing-students").classList.remove("--active");
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const modalIntroduction = document.getElementById('modal__introduction');
    const modalIntroductionModal = document.getElementById('modal__introduction-modal');
    const modalIntroductionClose = document.getElementById('modal__introduction-close');

    if (modalIntroductionModal) {
        modalIntroductionModal.addEventListener('click', function () {
            modalIntroduction.classList.add('--active');
        });
    }

    if (modalIntroductionClose) {
        modalIntroductionClose.addEventListener('click', function () {
            modalIntroduction.classList.remove('--active');
        });
    }
});


//ページ内リンク
// $(function () {
//     $('a[href*="#"]').click(function () {
//         var href = $(this).attr('href');
//         var target = $(href == '#' || href == '' ? 'html' : href);
//         var headerHeight = 80;
//         var position = target.offset().top - headerHeight;
//         $('html, body').animate({ scrollTop: position }, 300);
//         return false;
//     });
// });